import classNames from "classnames";
import { useState } from "react";
import Button from "./Button";
import Icon from "./Icon";
import "./ImageFullSizeButton.css";

type Props = {
    url: string;
    alt?: string | undefined;
    className?: string;
    children?: React.ReactNode;
};

function ImageFullSizeButton({ url, alt = "", className, children }: Props) {
    const [showFullSize, setShowFullSize] = useState(false);
    return (
        <>
            <Button.Ghost
                onClick={() => {
                    setShowFullSize(!showFullSize);
                }}
                className={classNames("web-lib__image-full-size-button", className)}
            >
                {children ?? <img src={url} alt={alt ?? ""} />}
            </Button.Ghost>
            {showFullSize && (
                <div className="web-lib__image-full-size-button--fullsize">
                    <div className="web-lib__image-full-size-button--fullsize__close">
                        <Button.Ghost
                            onClick={() => {
                                setShowFullSize(false);
                            }}
                        >
                            <Icon.Close.Large.TextInverse />
                        </Button.Ghost>
                    </div>
                    <Button.Ghost
                        onClick={() => {
                            setShowFullSize(false);
                        }}
                    >
                        <img src={url} alt={alt ?? ""} />
                    </Button.Ghost>
                </div>
            )}
        </>
    );
}

export default ImageFullSizeButton;
